import { LocationsStatusResponse } from '../models/commonTypeScript';
import fetch from './fetch';
import getFetchHeaders from './getFetchHeaders';

export default async (): Promise<LocationsStatusResponse> =>
    fetch<LocationsStatusResponse>(
        '/locations/status',
        {
            method: 'GET',
            headers: await getFetchHeaders(),
        },
        true
    );
